import { useMemo } from "react";

import { COMING_SOON } from "@/constants";
import { useStore } from "@/hooks/store";
import { isNotNullOrUndefined } from "@/utils";

import { hapiHeroAdditionalComponents } from "./constants";
import styles from "./styles";
import { Button } from "../Button";
import { ScrollSnapping } from "../ScrollSnapping";

export const AvailableAchievement = () => {
  const achievements = useStore((store) => store.user.achievements);

  const availableLevels = useMemo(() => {
    const hapiHero = achievements?.find((el) => el.id === "hapiHero");
    if (!hapiHero) return [];
    return hapiHero.levels
      .map((level, index) => {
        if (level.complete || level.text === COMING_SOON) return null;
        return hapiHeroAdditionalComponents[index + 1]
          ? { ...hapiHeroAdditionalComponents[index + 1], title: level.text }
          : undefined;
      })
      .filter(isNotNullOrUndefined);
  }, [achievements]);

  if (!availableLevels.length) return null;

  return (
    <ScrollSnapping
      array={availableLevels}
      component={({ title, background, image, action }) => (
        <styles.ScrollElement $bg={background}>
          <p>{title}</p>
          <Button type="secondary" name={action.title} handler={action.handler} />
          <img src={image} />
        </styles.ScrollElement>
      )}
    />
  );
};
